import { getColor as getBaseColor } from '../../Loading/utils/loadingHelpers';

export const getColor = (theme, colorKey) => {
  if (!theme || !theme.colors) return '#333333'; // Text default fallback
  if (!colorKey) return (theme.colors.text && theme.colors.text.primary) || '#333333';
  return getBaseColor(theme, colorKey);
};

export const getFontSize = (theme, size) => {
  if (!theme || !theme.typography) return '16px';
  switch (size) {
    case 'xs': return theme.typography.fontSize.xs || '12px';
    case 'sm': return theme.typography.fontSize.sm || '14px';
    case 'lg': return theme.typography.fontSize.lg || '18px';
    case 'xl': return theme.typography.fontSize.xl || '24px';
    case 'md':
    default:
      return theme.typography.fontSize.md || '16px';
  }
};



// WEBPACK FOOTER //
// ./src/design-system/atoms/Text/utils/textHelpers.js